import { render, staticRenderFns } from "./materialContent.vue?vue&type=template&id=6accdbe0&scoped=true"
import script from "./materialContent.vue?vue&type=script&lang=js"
export * from "./materialContent.vue?vue&type=script&lang=js"
import style0 from "./materialContent.vue?vue&type=style&index=0&id=6accdbe0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6accdbe0",
  null
  
)

export default component.exports